import { ref, set, onValue, onDisconnect, serverTimestamp, off, get, push, update, remove } from 'firebase/database';
import { rtdb } from './config';

export { ref, set, onValue, onDisconnect, serverTimestamp, off, get, push, update, remove };

// ─── Presence ────────────────────────────────────────────────────────────────

export const companyPresenceRef = (companyId: string) => ref(rtdb, `presence/${companyId}`);
export const presenceRef        = (companyId: string, uid: string) => ref(rtdb, `presence/${companyId}/${uid}`);
export const notificationsRef   = (companyId: string, uid: string) => ref(rtdb, `notifications/${companyId}/${uid}`);
export const activeEditsRef     = (companyId: string) => ref(rtdb, `activeEdits/${companyId}`);
export const dashboardRef       = (companyId: string) => ref(rtdb, `dashboard/${companyId}`);

export interface UserPresenceData {
  uid: string;
  name: string;
  online: boolean;
  lastSeen: any;
}

export const setUserOnline = async (companyId: string, uid: string, name: string) => {
  if (!companyId || !uid) return;
  try {
    const userPresenceRef = presenceRef(companyId, uid);
    const userDbRef = ref(rtdb, `users/${uid}`);

    await set(userPresenceRef, {
      uid,
      name,
      online: true,
      lastSeen: serverTimestamp(),
    });

    // Also update users node
    await update(userDbRef, {
      isOnline: true,
      lastActive: serverTimestamp(),
    }).catch(() => {});

    // Set onDisconnect triggers
    await onDisconnect(userPresenceRef).set({
      uid,
      name,
      online: false,
      lastSeen: serverTimestamp(),
    });

    await onDisconnect(userDbRef).update({
      isOnline: false,
      lastActive: serverTimestamp(),
    }).catch(() => {});
  } catch (err) {
    console.warn('setUserOnline error:', err);
  }
};

export const touchUserPresence = async (companyId: string, uid: string, name?: string) => {
  if (!companyId || !uid) return;
  try {
    const userPresenceRef = presenceRef(companyId, uid);
    await update(userPresenceRef, {
      online: true,
      lastSeen: serverTimestamp(),
    });
    await update(ref(rtdb, `users/${uid}`), {
      isOnline: true,
      lastActive: serverTimestamp(),
    }).catch(() => {});
  } catch (err) {
    console.warn('touchUserPresence error:', err);
  }
};

export const setUserOffline = async (companyId: string, uid: string) => {
  if (!companyId || !uid) return;
  try {
    const userPresenceRef = presenceRef(companyId, uid);
    await update(userPresenceRef, {
      online: false,
      lastSeen: serverTimestamp(),
    });
    await update(ref(rtdb, `users/${uid}`), {
      isOnline: false,
      lastActive: serverTimestamp(),
    }).catch(() => {});
  } catch (err) {
    console.warn('setUserOffline error:', err);
  }
};
